export default [
    {
        path: '/error/403',
        name: 'lost',
        component: () => import('@/components/404.vue')
    }
]
